export const userViewEditUserInfo = () => ({
  type: 'User viewed edit information',
});
